module.exports = __webpack_public_path__ + "img/underline.2f4f43a4.svg";